module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/heading/heading.component.scss
// module id = ./src/app/features/typography/heading/heading.component.scss
// module chunks = main